module.exports = __webpack_public_path__ + "img/r6.9b6e0a0c.jpg";